<template>
    <div>
        <div class="main-button-bar">
            <el-row>
                <el-select v-model="params.shopId" clearable placeholder="选择店铺" class="search-item">
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-date-picker
                    type="month"
                    placeholder="起始统计日期"
                    v-model="params.startTime"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="month"
                    placeholder="截止统计日期"
                    v-model="params.endTime"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                <el-button type="primary" size="small" @click="report">查看</el-button>
            </el-row>
        </div>
        <div :style="'height:' + (this.$tools.mainHeight() - 60) + 'px;overflow:auto;'">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tooltip placement="right" effect="light">
                        <div slot="content">1、不包含已退款、退款中的订单</div>
                        <span>销售量</span>
                    </el-tooltip>
                </div>
                <div id="saleNumber"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tooltip placement="right" effect="light">
                        <div slot="content">1、不包含已退款、退款中的订单</div>
                        <span>销售额</span>
                    </el-tooltip>
                </div>
                <div id="saleCost"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-tooltip placement="right" effect="light">
                        <div slot="content">1、只包含审核通过的支出数据</div>
                        <span>支出额</span>
                    </el-tooltip>
                </div>
                <div id="expend"></div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>净利润({{$tools.parsecost(profitTotle, true)}})</span>
                </div>
                <div id="profit"></div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { Chart, registerInteraction, registerAction, ActionConstructor, getDelegationObject} from "@antv/g2";
// import { getDelegationObject, getScaleByField, isList, isSlider } from '../util';

export default {
    data() {
        return {
            char: { saleNumber: null, saleCost: null, expend: null, profit: null },
            shops: null,
            profitTotle: null,
            params: {
                shopId: null,
                startTime: null,
                endTime: null,
            },
        };
    },
    methods: {
        getShop() {
            let _this = this;

            _this.$http.post(
                ["taobao/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                "none"
            );
        },
        report() {
            let _this = this;

            if (
                !_this.params.shopId ||
                !_this.params.startTime ||
                !_this.params.endTime
            ) {
                _this.$message({
                    message: "店铺、时间等过滤条件不能为空",
                    type: "error",
                });
                return;
            }

            _this.$http.post(
                ["taobao/order/report", _this.params],
                [
                    function (data) {
                        if (data.sale) {
                            for (var i in data.sale) {
                                data.sale[i].cost = _this.$tools.parsecost(
                                    data.sale[i].cost
                                );
                            }

                            for (var i in data.expends) {
                                data.expends[i].cost = _this.$tools.parsecost(
                                    data.expends[i].cost
                                );
                            }
                        }
                        _this.totle = data;

                        _this.render(data);
                    },
                ],
                "none"
            );
        },
        render(data) {
            let _this = this;

            _this.renderStatck("saleNumber", data.sale, "date*num", "type");

            _this.renderStatck("saleCost", data.sale, "date*cost", "type",  _this.renderPro);

            _this.renderStatck("expend", data.expends, "date*cost", "type", _this.renderPro);

            _this.renderPro(data.sale, data.expends);
        },

        renderPro(d1, d2) {
             let _this = this;

            _this.renderStatck("profit", _this.marginData(d1, d2), "date*cost", "type")
        },

        marginData(d1, d2) {
            var data = [], cache = [];

            for (var i in d1) {
                data[d1[i].date] =  (data[d1[i].date] ? data[d1[i].date] : 0 ) + d1[i].cost;
            }

            for (var i in d2) {
                cache[d2[i].date] = (cache[d2[i].date] ? cache[d2[i].date] : 0 ) + d2[i].cost;
            }
            
            var result = [];
            var totle = 0;

            for (var i in data) {
                totle = totle + data[i] - cache[i];
                result.push({date: i, cost: data[i] - cache[i], type: "RMB"});
            }

            this.profitTotle = totle;
            
            return result;
        },

        renderStatck(name, data, position, type, action) {
            let _this = this;
            if (!this.char[name]) {
                this.char[name] = new Chart({
                    container: name,
                    autoFit: true,
                    height: 250,
                });

                registerInteraction('element-link', {
                    start: [
                        {trigger: 'interval:mouseenter', action: 'element-link-by-color:link'}
                    ],
                    end: [
                        {trigger: 'interval:mouseleave', action: 'element-link-by-color:unlink'}
                    ]
                });
                this.char[name].interaction('element-link');
                

                 if (action) {
                    registerAction('mylegendfilter', (function() {
                        return {
                            init: function() {},
                            filter: function() {
                                action(_this.char['saleCost'].filteredData, _this.char['expend'].filteredData);
                            }
                        }
                    }));

                    registerInteraction('legend-filter-my', {
                        start: [{trigger: 'legend:click', action: 'mylegendfilter:filter'}]
                    });

                    this.char[name].interaction('legend-filter-my');
                 }

                this.char[name].tooltip({
                    shared: true,
                    customContent: (name, items) => {
                        const container = document.createElement("div");
                        container.className = "g2-tooltip";

                        let html = [];
                        html.push(`<div class="g2-tooltip-title" style="margin-top: 12px;margin-bottom: 12px;">${name}</div>`);

                        let count = window.parseFloat(0);
                        items.forEach((item) => {
                            html.push(`<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;display:flex;align-items: center;">`);
                            html.push(` <span style="background-color:${item?.mappingData?.color || item?.color};" class="g2-tooltip-marker"></span>`);
                            html.push(` <span style="display:inline-flex;flex:1;justify-content:space-between">`);
                            html.push(`     <span style="margin-right: 16px;">${item?.name}:</span><span>${item?.value}</span>`);
                            html.push(` </span>`);
                            html.push(`</li>`);
                            count += window.parseFloat(item.value);
                        });

                        html.push(`<li class="g2-tooltip-list-item" style="margin-bottom:4px;display:flex;align-items: center;">`);
                        html.push(` <span style="background-color:#BBB;" class="g2-tooltip-marker"></span>`);
                        html.push(` <span style="display:inline-flex;flex:1;justify-content:space-between">`);
                        html.push(`     <span style="margin-right: 16px;">共计:</span><span>`, count, `</span>`);
                        html.push(` </span>`);
                        html.push(`</li>`);

                        container.innerHTML = html.join("");
                        return container;
                    },
                })

                if (name == "profit") {
                    this.char[name]
                        .interval()
                        .position(position)
                        .color("cost", value => {
                            return (window.parseFloat(value) >= 0 ? "green" : "red");
                        });
                } else {
                 this.char[name]
                    .interval()
                    .position(position)
                    .color(type)
                    .adjust(["stack"]);
                }
            }

            this.char[name].data(data);
            this.char[name].render();
        },
    },
    mounted() {
        this.getShop();
    },
};
</script>

<style lang="scss">
</style>